import { createContext } from 'react';

const Web3Context = createContext({
  logs: []
});

export default Web3Context;